import { useNavigate } from "react-router-dom";
import React from "react";

const UMobileHero: React.FC = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/onboard');
  };

  return (
    <section className=" py-16 text-center relative overflow-hidden">
      {/* Background Image */}
      <img
        src={`${process.env.PUBLIC_URL}/ic_banner_onboarding_process-55743e32.png`}
        alt="U Mobile Hero Background"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-transparent to-black opacity-30"></div>

      {/* Overlay Content */}
      <div className="relative z-10 px-4 sm:px-8">
        <h1 className="font-custom text-5xl font-bold mb-4 text-black">U Mobile Developer Hub</h1>
        <h2 className="font-custom font-medium text-xl mb-8 text-gray-800">
          Discover the Unbeatable 5G experience we have for U
        </h2>
        <p className=" text-lg text-gray-700 mx-auto mb-8 max-w-2xl">
          You're a step closer to the future with U Mobile. Our Network APIs bring
          unbeatable capabilities to your solutions, helping you build the next
          "wow" moment for U and your business. Visit our Developer Hub and start building today.
        </p>
        <p className="text-lg text-gray-700 mx-auto mb-8 max-w-2xl">
          Visit our Developer Hub and start building today.
        </p>
        <button
          onClick={handleGetStarted}
          className="bg-orange-100 text-white text-lg font-semibold px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl active:scale-95 active:shadow-md"
          aria-label="Navigate to the onboarding page"
        >
          Get Started!
        </button>
      </div>
    </section>
  );
};

export default UMobileHero;
